import React from "react";
import {Route, withRouter} from "react-router-dom";

class ListeningRoute extends React.PureComponent {
    componentWillMount() {
        this.unlisten = this.props.history.listen(location => this.setState({location}));
    }

    componentWillUnmount() {
        try {
            this.unlisten();
        } catch(e) {
            console.warn('ListeningRoute', e);
        }
    }

    render() {
        return <Route {...this.props} {...this.state} />;
    }
}
export default withRouter(ListeningRoute);


// WEBPACK FOOTER //
// ./src/components/ListeningRoute.js